export enum DiscountType {
  credit = 'credit',
  coupon = 'coupon',
}
